import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 3.1rem;

  position: sticky;
  top: 0;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  margin: 0.8rem 0;

  > a,
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;

    padding: 0.4rem;

    border-radius: 0.2rem;

    transition: ${({ theme }) => theme.transition.default};

    :hover {
      transform: scale(1.05);
    }

    :active {
      transform: scale(0.99);
    }
    background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);

    :last-child {
      background: transparent linear-gradient(155deg, #b50808 0%, #d90606 100%);
    }
  }

  @media (min-width: 425px) {
    > a,
    button {
      border-radius: 50%;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;

    margin: 0;

    > a,
    button {
      min-width: 3.3rem;
      min-height: 3.3rem;
    }

    > button {
      margin-top: 0rem;
      margin-left: 1.6rem;
    }
  }
`;

export const Container = styled.div`
  margin: 3.6rem 6.2rem;
  max-width: 60%;
`;

export const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;

  div {
    color: white;
    font-size: 1.8rem;
    margin-bottom: 3.3rem;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #ffffff80;
  margin-bottom: 3.3rem;
`;

export const SerieContainer = styled.li``;

export const SerieSection = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;

  div {
    color: white;
    font-size: 1.8rem;
    margin-bottom: 3.3rem;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;
